import type { TripViewDTO } from '@serviquim/contracts';
import { useT } from '../i18n';
import type { PendingExpense } from '../lib/db';
import { discardPendingExpense, retryPendingExpense } from '../lib/sync';
import { ExpenseRow } from './ExpenseRow';
import { Card } from './ui/Card';

function handleRetry(localId: number | undefined): void {
  if (localId === undefined) return;
  void retryPendingExpense(localId);
}

function handleDiscard(localId: number | undefined): void {
  if (localId === undefined) return;
  void discardPendingExpense(localId);
}

export function TripExpensesList({
  expenses,
  pending,
}: {
  expenses: TripViewDTO['expenses'];
  pending: PendingExpense[];
}) {
  const { t } = useT();
  if (expenses.length === 0 && pending.length === 0) {
    return (
      <Card className="p-0">
        <p className="px-4 py-6 text-center text-sm text-ink-muted">{t('expenses.emptyList')}</p>
      </Card>
    );
  }

  return (
    <Card className="p-0">
      <div className="px-4">
        {pending.map((item) => (
          <ExpenseRow
            key={item.localId}
            descricao={item.descricao}
            valor={item.valor}
            photoUrl={item.fotoDataUrl}
            status={item.status}
            errorMessage={item.lastError}
            onRetry={item.status === 'failed' ? () => handleRetry(item.localId) : undefined}
            onDiscard={item.status === 'failed' ? () => handleDiscard(item.localId) : undefined}
          />
        ))}
        {expenses.map((expense) => (
          <ExpenseRow
            key={expense.id}
            descricao={expense.descricao}
            valor={expense.valor}
            photoUrl={expense.fotoUrl ?? undefined}
            status="synced"
          />
        ))}
      </div>
    </Card>
  );
}
